export default "## Thank you for submitting your sell information\n\nWe have received your details and our car buying team will begin assessing your car.\n";